const DashBoardView = () => {
  return <div>DashBoardView</div>;
};

export default DashBoardView;
